/* eslint-disable import/prefer-default-export */
export const FORBIDDEN_ACTIONS_BY_COUNTRY = {
  like: {
    ru: true,
  },
  share: {
    ru: true,
  },
};
